module.exports = __webpack_public_path__ + "static/media/bulario.324d1cf4.svg";